/* v27 (owner, 2026-10-28: "make them glide behind"): the problems behind the phone demo (dex-phone, dex-v30.css). Each
   row's speed is set from its length, so a long Georgian row moves at the same pace as an English one, and the rows only
   move while the section is on screen. With less motion they stand still (the CSS). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-dex-pb]').forEach(function (bg) {
    var rows = bg.querySelectorAll('.dex-pb__track');
    var pace = [26, 38, 30, 34, 22]; // px a second, per row
    var lastW = 0;
    var size = function () {
      // a phone's address bar showing and hiding is not a resize worth restarting the rows for
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      var k = window.innerWidth < 750 ? 0.7 : 1;
      rows.forEach(function (t, i) {
        var half = t.scrollWidth / 2;
        if (half > 0) t.style.setProperty('--dex-pb-dur', (half / (pace[i % pace.length] * k)).toFixed(1) + 's');
      });
    };
    size();
    window.addEventListener('resize', size);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { lastW = 0; size(); });
    if (reduce) return;
    if (!('IntersectionObserver' in window)) { bg.classList.add('is-on'); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bg.classList.toggle('is-on', e.isIntersecting); });
    }, { rootMargin: '120px 0px' }).observe(bg);
  });
})();
